module.exports = __webpack_public_path__ + "img/menu-bar-off_04.2709de1f.png";